import Activity from '../classes/activity';

const activities = (state = {}, action) => {
  switch (action.type) {
    case 'SET_ACTIVITIES':
      return {
        ...action.activities,
      };
    case 'ADD_ACTIVITY':
      console.assert(
        !Object.hasOwnProperty.call(state, action.activity.activityId),
        'activityId must be unique within the scene',
      );
      state[action.activity.activityId] = new Activity(
        action.activity,
        Object.keys(state).length,
        action.numActivities,
        action.scene,
      );
      return { ...state };
    case 'DELETE_ACTIVITY': {
      const newState = { ...state };
      delete newState[action.activityId.toString()];
      return newState;
    }
    case 'TOGGLE_ACTIVITY_VISIBILITY': {
      const updateActivity = { ...state[action.activityId] };
      updateActivity.show = !state[action.activityId].show;
      return { ...state, [action.activityId]: updateActivity };
    }
    case 'SET_TRAIL_LENGTH': {
      const newObj = {};
      Object.keys(state).forEach(a => {
        newObj[a] = { ...state[a] };
        newObj[a].trailLength = action.trailLength;
      });
      return newObj;
    }
    default:
      return state;
  }
};

export default activities;
